export enum FixedAssetsScheduleTableType {
    COSTS = 'COSTS',
    DEPRECIATION = 'DEPRECIATION',
    VALUE_APPRECIATION = 'VALUE APPRECIATION',
}
